import { render } from "./IconCreditCard.vue?vue&type=template&id=606bd5a4"
import script from "./IconCreditCard.vue?vue&type=script&lang=js"
export * from "./IconCreditCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__